export function init(obj) {
  if (window.xy_bj_reporter) {
    window.xy_bj_reporter.init(obj);
  } else {
    window._xy_bj_reporter_init = obj;
  }
}
export function report(param) {
  let re = {};
  let url=window.document.location.href
  let params=Object.assign({url:url,referrer:document.referrer},param)
  if (window.xy_bj_reporter) {

    re = window.xy_bj_reporter.report(params);
  }
  return re;
}
let reportBindNum = 0;
const reportBindData = {};
/**
 * JQUERY的DOM对象。如此上报事件需要重复绑定覆盖上次绑定的上报参数，
 * 则传入的jqObj应为上一次传入的对象，否则不能卸载上一次绑定的事件，导致上报事件越来越多。
 * 应注意。
 * @param jqObj
 * @param param
 * @param eventType
 */
export function reportBind(jqObj, param, eventType = 'click') {
  if (!jqObj) {
    console.error('reportBind没有obj',param);
    return;
  }
  if (jqObj.reportBindId) {
    jqObj.off(eventType, reportBindData[jqObj.reportBindId]);
  } else {
    reportBindNum++;
    jqObj.reportBindId = 'r_' + eventType + '_' + reportBindNum;
  }
  let handler = reportBindData[jqObj.reportBindId] = () => {
    report(param);
  };
  jqObj.on(eventType, handler);
}
export default {
  init,
  report,
  bind: reportBind,
};



// WEBPACK FOOTER //
// ./src/component/common/report.js